import { SipNumberBulkCreateRequest } from "../../model/sipNumberBulkCreateRequest";
import { fetchPostJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = SipNumberBulkCreateRequest;

export async function postSipNumbersBulk(payload: DtoType) {
  try {
    const url = apiUrls.postSipNumbersBulk;
    return await fetchPostJSON(url, payload);
  } catch (err) {
    console.error("API Error - postSipNumbersBulk:", err);
  }
}
